<template>
  <div>
    <md-progress-bar
      v-if="loading"
      md-mode="query"
    />
    <md-table
      v-if="!loading"
      v-model="serverBundles"
      :table-header-color="tableHeaderColor"
    >
      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
      >
        <md-table-cell md-label="name">
          {{ item.name }}
        </md-table-cell>

        <md-table-cell md-label="comment">
          {{ item.comment }}
        </md-table-cell>

        <md-table-cell md-label="Edit">
          <md-button
            class="md-icon-button"
            @click="onEditButtonClick(item)"
          >
            <md-icon>edit</md-icon>
          </md-button>
        </md-table-cell>

        <md-table-cell md-label="Delete">
          <md-button
            class="md-icon-button"
            @click="onDeleteButtonClick(item)"
          >
            <md-icon>delete</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-active.sync="deleteDialog.isShown"
      :md-title="`Delete sever bundle ${deleteDialog.deletedServerBundle.name}?`"
      md-content="Deleting server bundle will remove any links to nodes and shortcuts and no longer can be restored"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="deleteServerBundle"
    />

    <md-dialog :md-active.sync="editDialog.isShown">
      <md-dialog-title>Update "{{ editDialog.editedServerBundle.name }}" server bundle</md-dialog-title>

      <md-dialog-content>
        <md-field :class="{ 'md-invalid invalid-field': $v.editDialog.fields.name.$error }">
          <label>Name</label>
          <md-input v-model="editDialog.fields.name" />
          <span class="md-error">Field must not be empty</span>
        </md-field>

        <md-field>
          <label>Comment</label>
          <md-textarea v-model="editDialog.fields.comment" />
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          @click="editDialog.isShown = false"
        >
          Close
        </md-button>

        <md-button
          class="md-primary"
          @click="updateServerBundle"
        >
          Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "ServerBundlesTable",
        props: {
            tableHeaderColor: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                loading: true,
                selected: [],
                serverBundles: [],
                componentKey: 0,

                deleteDialog: {
                  isShown: false,
                  deletedServerBundle: {}
                },

                editDialog: {
                  isShown: false,
                  editedServerBundle: {},

                  fields: {
                    name: "",
                    comment: ""
                  }
                }
            };
        },
        mounted() {
            this.getServerBundles();
        },
        methods: {
            getServerBundles() {
                this.$http.get("/v1/admin/node/server-bundles").then(result => {
                    this.serverBundles = result.data.server_bundles;
                    this.loading = false;
                }, err => {
                    console.error(err);
                });
            },
            onDeleteButtonClick(serverBundle) {
                this.deleteDialog.isShown = true;
                this.deleteDialog.deletedServerBundle = serverBundle;
            },
            deleteServerBundle() {
                this.$http.delete(`/v1/admin/node/server-bundle/${this.deleteDialog.deletedServerBundle.id}`)
                  .then(() => {
                    this.$notify({
                      group: "foo",
                      title: `Server bundle ${this.deleteDialog.deletedServerBundle.name} deleted`,
                    });
                    this.serverBundles = this.serverBundles.filter(
                      bundle => bundle.id !== this.deleteDialog.deletedServerBundle.id
                    );
                    this.deleteDialog = {
                      isShown: false,
                      deletedServerBundle: {}
                    };
                  }, err => {
                    console.error(err);
                    this.$notify({
                      group: "foo",
                      title: `Couldn't delete server bundle: ${err}`,
                    });
                  });
            },
            onEditButtonClick(serverBundle) {
                this.editDialog = {
                  isShown: true,
                  editedServerBundle: {...serverBundle},
                  fields: {
                    name: serverBundle.name,
                    comment: serverBundle.comment,
                  }
                };
            },
            updateServerBundle() {
                this.$v.editDialog.fields.$touch();

                if (this.$v.editDialog.fields.$error) {
                  return;
                }

                const updatedServerBundle = { ...this.editDialog.editedServerBundle, ...this.editDialog.fields };

                this.$http.put("/v1/admin/node/server-bundle/update", { server_bundle: updatedServerBundle })
                  .then(() => {
                    this.$notify({
                      group: "foo",
                      title: `Server bundle ${this.editDialog.editedServerBundle.name} updated`,
                    });
                    this.serverBundles = this.serverBundles.map(
                      bundle => bundle.id === this.editDialog.editedServerBundle.id
                        ? updatedServerBundle
                        : bundle
                    );
                    this.editDialog.isShown = false;
                  }, err => {
                    console.error(err);
                    this.$notify({
                      group: "foo",
                      title: `Couldn't update server bundle: ${err}`,
                    });
                  });
            }
        },
        validations: {
          editDialog: {
            fields: {
              name: { required }
            }
          }
        }
    };
</script>
